import { JRCIcon } from 'components/JRCIcon/JRCIcon';
import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

export const CSSAlert = styled.button`
    border: 1px dashed ${(props) => props.theme.color.orange};
    padding: ${(props) => props.theme.space.sm}px;
    border-radius: ${(props) => props.theme.space.sm}px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    margin-top: ${(props) => props.theme.space.sm}px;
`;

export const CSSWrapper = styled.div`
    display: flex;
    flex-direction: row;
`;

export const ExcelEditorBrokenModel = () => {
    const intl = useIntl();
    return (
        <>
            <CSSAlert>
                <JRCIcon name={'icon-warning'} color={'orange'} />
                <div>{intl.formatMessage({ id: 'WIDGET_Datasource_Excel_Broken_Model' })}</div>
            </CSSAlert>
        </>
    );
};
